export const navLinksData = [
          {
                    _id: 1001,
                    title: "About",
                    link: "about",
          },
          {
                    _id: 1002,
                    title: "Services",
                    link: "services",
          },
          {
                    _id: 1003,
                    title: "Portfolio",
                    link: "portfolio",
          },
          {
                    _id: 1004,
                    title: "Contact",
                    link: "contact",
          },
];